import type { SyncConflictsReport } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const getSyncConflicts = async (): Promise<SyncConflictsReport> => {
  const response = await apiClient.get<SyncConflictsReport>('/directory/sync/conflicts');
  return response.data;
};
